<template>
  <div class="cj-popup">
    <slot />
    <button class="close" @click="dismissClicked" />
  </div>
</template>

<script>
export default {
  name: 'CJPopup',

  methods: {
    dismissClicked () {
      this.$emit('dismiss')
    },
  },
}
</script>

<style lang="stylus" scoped>
  .cj-popup
    position: absolute
    top: 48.5%
    left: 50%
    width: 310px
    height: 290px
    background-color: rgba(255, 255, 255, 0.92)
    color: #1a294a
    transform: translate(-50%, -50%)

    > button.close
      position: absolute
      top: 0
      right: 0
      cursor: pointer
</style>
